import React from 'react'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'react-chartjs-2'
import { ITotalAnalysisData } from 'services/NGT/Cockpit'
import { COLORS } from 'utils'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface StackedBarChart {
  data: ITotalAnalysisData[]
  labels: string[]
}

const StackedBarChart: React.FC<StackedBarChart> = ({ data, labels = [] }) => {
  const formatedData = {
    datasets: [
      {
        // Quarta barra
        backgroundColor: COLORS.blueFonts,
        data: data?.map((item) => item.qtdItensAnalisados),
        label: labels[1]
      },
      {
        // Primeira barra
        backgroundColor: COLORS.tableColor,
        data: data?.map((item) => item.qtdAnalisado),
        label: labels[2]
      },
      {
        // Segunda barra
        backgroundColor: COLORS.alert,
        data: data?.map((item) => item.qtdPendente),
        label: labels[3]
      },
      {
        // Terceira barra
        backgroundColor: COLORS.error,
        data: data?.map((item) => item.qtdBacklog),
        label: labels[4]
      },
      {
        // Texto do total
        backgroundColor: COLORS.success,
        data: data?.map(
          (item) => item.qtdPendente + item.qtdItensAnalisados
        ),
        label: 'Total'
      }
    ],
    labels: data?.map((item) => monthNameByNumber(item.anoMes))
  }

  const parseToDecimal = (value: number) => {
    if (value < 1000) {
      return String(value)
    } else {
      const numeroDecimal = Intl.NumberFormat('pt-BR', { maximumFractionDigits: 3 }).format(value)
      return String(numeroDecimal)
    }
  }

  return (
    <Bar
      options={{
        plugins: {
          datalabels: {
            color: ({ datasetIndex: index }: any) =>
              index === 0 ? 'white' : 'black',
            // Realiza a formatação, adicionado pontuação aos valores
            formatter: function (value) {
              return parseToDecimal(value)
            }
          },
          legend: {
            display: true,
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Total de Análise - Mensal'
          }
        },
        responsive: true,
        scales: {
          x: {
            stacked: true
          },
          y: {
            stacked: true
          }
        }
      }}
      data={formatedData}
      plugins={[ChartDataLabels]}
    />
  )
}

const monthNameByNumber = (monthNumber: number) => {
  const months = [
    'Mês inválido',
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ]
  return months[monthNumber] || months[0]
}

export default StackedBarChart
